import actions from "./actions";

const initialState = {
  loading: false,
  toBeStarted: [],
  prepared: [],
  spraying: [],
  history: [],
  error: null,
};

export default function sprayReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_SPRAY_JOBS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.FETCH_SPRAY_JOBS_SUCCESS:
      return {
        ...state,
        loading: false,
        toBeStarted: action.payload.toBeStarted,
        prepared: action.payload.prepared,
        spraying: action.payload.spraying,
        history: action.payload.history,
      };
    case actions.FETCH_SPRAY_JOBS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};
